module.exports = __webpack_public_path__ + "media/packs/images/flags/GG-4cbdd960f464e1016628bc30d93a3e78.png";